import FlexPane from './_flex-pane.js'
import GenericBetFundsInfo from './_generic-bet-funds-info.js'

export default {
  name: 'PrewagerStakeInfo',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    cash: {
      configSet: GenericBetFundsInfo,
      configValues: {},
    },
    bonus: {
      configSet: GenericBetFundsInfo,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
